// extracted by css-extract-rspack-plugin
export default {"iconCheckbox":"s3_wtffypEo15hnG"};